import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// 🔹 Load from localStorage
const API_URL = window.location.origin.includes("192.168")
  ? "http://192.168.1.101:5010/api/"
  : "http://localhost:5010/api/";

const adminFromStorage = JSON.parse(localStorage.getItem("admin"));

const initialState = {
  admin: adminFromStorage || null,
  loading: false,
  error: null,
};

// 🔥 LOGIN API
export const loginAdmin = createAsyncThunk(
  "admin/login",
  async (data, thunkAPI) => {
    try {
      const res = await axios.post(`${API_URL}login`, data, {
        headers: { "Content-Type": "application/json" },
      });

      const result = res.data;

      // ✅ Save in localStorage
      localStorage.setItem("admin", JSON.stringify(result.admin));

      return result.admin;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

// 🔥 UPDATE PROFILE
export const updateProfile = createAsyncThunk(
  "admin/updateProfile",
  async (data, thunkAPI) => {
    try {
      const res = await axios.post(`${API_URL}update_profile`, data, {
      });

      const result = res.data;

      // ✅ localStorage update
      localStorage.setItem("admin", JSON.stringify(result.admin));

      return result.admin;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

// 🔥 CHANGE PASSWORD
export const changePassword = createAsyncThunk(
  "admin/changePassword",
  async (data, thunkAPI) => {
    try {
      const res = await axios.post(`${API_URL}change_password`, data, {
        headers: { "Content-Type": "application/json" },
      });

      return res.data.message; // ✅ direct return
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    logout: (state) => {
      state.admin = null;
      localStorage.removeItem("admin");
    },
  },
  extraReducers: (builder) => {
    builder
      // LOGIN
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.admin = action.payload;
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ✅ UPDATE PROFILE (ONLY ONCE)
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.admin = action.payload;

        // localStorage sync
        localStorage.setItem("admin", JSON.stringify(action.payload));
      })
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
      })
    .addCase(changePassword.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(changePassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
}
});

export const { logout } = adminSlice.actions;
export default adminSlice.reducer;